import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countTotalPriceBom',
    standalone: false
})
export class CountTotalPriceBomPipe implements PipeTransform {

  transform(priceAccessories: string, priceBom?: string, priceProjectComponents?: string): number {
    if (priceBom) {
      return parseFloat(priceAccessories) + parseFloat(priceBom) + parseFloat(priceProjectComponents ?? '0');
    }
  }

}
